import { HeaderContainer } from "./Component";

const Header= ({Click}) => {
    return (  
        <HeaderContainer Click={Click}/>
    );
}
 
export default Header